export default "__VITE_ASSET__DcdC5mLF__"